<template>
	<div class="diagens-mob-overview">
		<div class="diagens-mob-overview__img-wrapper">
			<img :src="cover.half01" class="diagens-mob-overview__img" />
		</div>
		<div class="diagens-mob-overview__img-wrapper">
			<img :src="cover.half02" class="diagens-mob-overview__img" />
		</div>
	</div>
</template>

<script setup>
import { computed } from 'vue';
import i18n, { EN, ZH, ZH_HK } from '@/locales';

const coverMap = {
	[EN]: {
		half01: require('./half_01_en.png'),
		half02: require('./half_02_en.png')
	},
	[ZH]: {
		half01: require('./half_01_cn.png'),
		half02: require('./half_02_cn.png')
	},
	[ZH_HK]: {
		half01: require('./half_01_hk.png'),
		half02: require('./half_02_hk.png')
	}
};

const cover = computed(() => ({
	half01: coverMap[i18n.locale].half01,
	half02: coverMap[i18n.locale].half02
}));
</script>

<style lang="less" scoped>
.diagens-mob-overview {
	display: flex;
	flex-direction: column;
	font-size: 0;

	&__img-wrapper {
		flex: 1;
	}
	&__img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
}
</style>
